import * as React from "react";
const DEFAULTS = {
  getIcon: (name) => {
    return null;
  }
};
const Context = React.createContext(DEFAULTS);
export const IconProvider = (props) => {
  return /* @__PURE__ */ React.createElement(Context.Provider, { value: props.config || DEFAULTS }, props.children);
};
IconProvider.displayName = "IconProvider";
export const useIcons = () => React.useContext(Context);
const iconCache = {};
const bundlePath = "icons/svg-icons.svg";
const currentUrl = typeof window === "undefined" || !window?.location?.href ? null : new URL(window.location.href);
const prodHost = "https://www.egencia.com";
const testHost = "https://www.egencia-test.com";
const isInternetExplorer = typeof navigator !== "undefined" && (navigator.userAgent.toUpperCase().includes("TRIDENT/") || navigator.userAgent.toUpperCase().includes("MSIE"));
const isLocal = currentUrl === null || /localhost|local\.egencia/.test(currentUrl.origin);
const isPortForwarded = currentUrl === null || /(\d+\.\d+.\d+.\d+):\d{4}/.test(currentUrl.host);
const isEmbedded = currentUrl !== null && ["data:", "file:"].includes(currentUrl.protocol);
const requiresFallback = isLocal || isPortForwarded || isInternetExplorer || isEmbedded;
const insertSvgIntoDom = (text) => {
  if (typeof document !== "undefined") {
    document.head.insertAdjacentHTML("beforeend", text);
  }
};
function determineIconsSvgBundle(currentURL) {
  if (isInternetExplorer) {
    return new URL(bundlePath, prodHost);
  }
  if (isEmbedded || isPortForwarded || isLocal) {
    return new URL(bundlePath, testHost);
  }
  return new URL(bundlePath, currentURL.origin);
}
const globalVar = globalThis ?? global;
const fallbackPromise = (
  // @ts-ignore
  requiresFallback && globalVar.fetch && currentUrl ? fetch(determineIconsSvgBundle(currentUrl).toString()).then((r) => r.text()).then(insertSvgIntoDom) : Promise.resolve()
);
function Icon({ name, style }) {
  if (typeof name !== "string")
    throw new Error("Please use an icon name");
  const currentURL = typeof window === "undefined" || !window?.location?.href ? null : new URL(window.location.href);
  if (!currentURL)
    return /* @__PURE__ */ React.createElement("svg", { style });
  const iconsSvgBundle = determineIconsSvgBundle(currentURL);
  const anchor = `#${name}`;
  const canonicalURL = iconsSvgBundle + anchor;
  const [hasFallbackSvgDoc, setHasFallbackSvgDoc] = React.useState(false);
  React.useEffect(() => {
    fallbackPromise.then(() => {
      setHasFallbackSvgDoc(requiresFallback);
    });
  }, []);
  const href = hasFallbackSvgDoc ? anchor : requiresFallback ? "" : canonicalURL;
  if (requiresFallback && !hasFallbackSvgDoc) {
    return /* @__PURE__ */ React.createElement("svg", { style });
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox: "0 0 24 24",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      xmlns: "http://www.w3.org/2000/svg",
      style
    },
    /* @__PURE__ */ React.createElement("use", { href, xlinkHref: requiresFallback ? "" : canonicalURL })
  );
}
function getCachedIcon(name) {
  const newIcon = iconCache[name] ?? (({ style }) => /* @__PURE__ */ React.createElement(Icon, { style, name }));
  if (!iconCache[name]) {
    iconCache[name] = newIcon;
  }
  return newIcon;
}
export const egenciaIconConfig = {
  getIcon: getCachedIcon
};
